// Helper function to generate UUID
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const defaultState = {
    items: [],
    uuid: generateUUID() // Generate initial UUID for new cart
}

// basic reducer for cart to update it
export const cartReducer = (state = defaultState, action) => {
    switch (action.type) {
        case "UPDATE_CART" :
            // Check if payload is a complete cart object or just an items array
            const isCartObject = action.payload && typeof action.payload === 'object' && 
                                  action.payload.hasOwnProperty('items');

            let newItems = [];
            if (isCartObject) {
              newItems = action.payload.items;
            } else {
              newItems = Array.isArray(action.payload) ? action.payload : [];
            }

            let uuid = state.uuid ?? action.payload.uuid;
            // Generate new UUID only when cart becomes empty or first item is added
            const shouldGenerateNewUUID =
                !uuid || // No initial uuid.
                (state.items.length === 0 && newItems.length > 0) || // First item added
                (state.items.length > 0 && newItems.length === 0);   // Cart cleared

           const cart = {
             ...state,
             items: newItems,
             uuid: shouldGenerateNewUUID ? generateUUID() : uuid
           };
           return cart;

        case "CLEAR_CART" :
            return {
                ...state, 
                items: action.payload,
                uuid: generateUUID() // Always generate new UUID when explicitly clearing cart
            };

        default:
            return state
    }
}